import { render, staticRenderFns } from "./AppHead.vue?vue&type=template&id=30a59b58&scoped=true&"
import script from "./AppHead.vue?vue&type=script&lang=ts&"
export * from "./AppHead.vue?vue&type=script&lang=ts&"
import style0 from "./AppHead.vue?vue&type=style&index=0&id=30a59b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a59b58",
  null
  
)

component.options.__file = "AppHead.vue"
export default component.exports